import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './styles.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing || sessionStorage.getItem('rowsprint-sw-refresh') === '1') return;
    refreshing = true;
    sessionStorage.setItem('rowsprint-sw-refresh', '1');
    window.location.reload();
  });

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' });
      await registration.update();
      sessionStorage.removeItem('rowsprint-sw-refresh');
    } catch {
      // Die App bleibt auch ohne Service Worker vollständig spielbar.
    }
  });
}
